// extracted by mini-css-extract-plugin
export var box = "_68-0";
export var check = "_68-1";
export var checkboxButton = "_68-6";
export var checkboxGroup = "_68-5";
export var disabled = "_68-7";
export var ghost = "_68-9";
export var input = "_68-2";
export var label = "_68-4";
export var normal = "_68-8";
export var uncheck = "_68-3";